'use strict';

// Utils
import matchJS from './utils/matchJS';
import { initReact } from './utils/initReact';

// Routes
import Materials from './routes/materials';


var APP = {
  materialscenter: {
    index() {
      initReact(document.getElementById('app'), Materials);
    },
  },
}

document.addEventListener('DOMContentLoaded', matchJS.init(APP));